import StopState from "./StopState";

export const SET_STOPS = "SET_STOPS";
export const SET_STOPS_STATE = "SET_STOPS_STATE";

interface ActionTypes {
  SET_STOPS_STATE: string;
  SET_STOPS: string;
}

export interface MessageAction {
  type: keyof ActionTypes;
  payload: any;
}

export function setStopState(
  stopIds: number[],
  state: StopState
): StopActionTypes {
  return {
    type: SET_STOPS_STATE,
    payload: { stopIds, state },
  };
}

export function setStops(stops: any[]): StopActionTypes {
  return {
    type: SET_STOPS,
    payload: stops,
  };
}

export type StopActionTypes = MessageAction;
